import { IUserArtist } from "types/user";
import { GetUser } from "./getUser";

export const SetUser = (userData: object) => {
  localStorage.setItem("userData", JSON.stringify(userData));
};

export const SetUserSubscription = (subscription: string) => {
  const user = GetUser();
  if (user) {
    const updatedUser = { ...user, subscription };
    SetUser(updatedUser);
  }
};

export const UpdateArtistData = (artistData: IUserArtist) => {
  const user = GetUser();
  const artistProfiles = user?.artistProfiles;
  if (artistProfiles) {
    const updatedProfiles = artistProfiles.map((profile) =>
      profile.id === artistData.id ? artistData : profile
    );
    SetUser({ ...user, artistProfiles: updatedProfiles });
  }
};

export const AddArtistData = (artistData: IUserArtist) => {
  const user = GetUser();
  const artistProfiles = user?.artistProfiles;
  if (artistProfiles) {
    const updatedProfiles = [...artistProfiles, artistData];
    SetUser({ ...user, artistProfiles: updatedProfiles });
  }
};
